import { ArrowUpRight, LockKeyhole, Mail, PackageCheck } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { company } from "../config/company.js";
import { subscribeNewsletter } from "../lib/api.js";
import { Logo } from "./Logo.jsx";

export function Footer() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  async function submit(event) {
    event.preventDefault();
    try {
      await subscribeNewsletter(email);
      setMessage("Merci, votre inscription est confirmée.");
      setEmail("");
    } catch {
      setMessage("Le formulaire sera actif dès que MongoDB sera connecté.");
    }
  }

  return (
    <footer className="footer">
      <div className="container footer__trust">
        <div><PackageCheck /><span><strong>Expédition rapide</strong>Préparée sous 24h ouvrées</span></div>
        <div><LockKeyhole /><span><strong>Paiement protégé</strong>Données chiffrées et sécurisées</span></div>
        <div><Mail /><span><strong>Une équipe joignable</strong>{company.email}</span></div>
      </div>
      <div className="container footer__main">
        <div className="footer__brand">
          <Logo />
          <p>L’affranchissement officiel, plus simple, plus clair et toujours au juste prix.</p>
          <div className="footer__contact">
            <a href={`mailto:${company.email}`}>{company.email} <ArrowUpRight size={15} /></a>
            {company.phones.map((phone) => <a key={phone.href} href={`tel:${phone.href}`}>{phone.display}</a>)}
            <address>{company.contactAddress}</address>
            <small>{company.openingHours}</small>
          </div>
        </div>
        <div className="footer__links">
          <div><h3>Explorer</h3><Link to="/boutique">Boutique</Link><Link to="/promotions">Promotions</Link><Link to="/comment-ca-marche">Comment ça marche</Link><Link to="/faq">FAQ</Link></div>
          <div><h3>Ecotimbre</h3><Link to="/a-propos">À propos</Link><Link to="/livraison">Livraison</Link><Link to="/paiement-securise">Paiement sécurisé</Link><Link to="/contact">Contact</Link></div>
          <div><h3>Légal</h3><Link to="/cgv">CGV</Link><Link to="/mentions-legales">Mentions légales</Link><Link to="/politique-de-confidentialite">Confidentialité</Link></div>
        </div>
        <div className="newsletter">
          <span className="eyebrow">Le courrier utile</span>
          <h3>Des nouvelles qui valent le timbre.</h3>
          <p>Promotions et conseils d’envoi, sans surcharge.</p>
          <form onSubmit={submit}>
            <label className="sr-only" htmlFor="newsletter-email">Votre adresse e-mail</label>
            <input id="newsletter-email" type="email" required placeholder="vous@exemple.fr" value={email} onChange={(event) => setEmail(event.target.value)} />
            <button type="submit">S’inscrire</button>
          </form>
          {message && <small role="status">{message}</small>}
        </div>
      </div>
      <div className="container footer__bottom">
        <span>© {new Date().getFullYear()} Ecotimbre</span>
        <span>Conçu en France · Pensé pour tous les envois</span>
      </div>
    </footer>
  );
}
